import {
  PAYMENT_REQUEST_SET,
  PAYMENT_REQUEST_REMOVE,
} from './types';

export const removePaymentRequest = () => ({
  type: PAYMENT_REQUEST_REMOVE,
});

export const setPaymentRequest = props => ({
  type: PAYMENT_REQUEST_SET,
  data: props,
});



// WEBPACK FOOTER //
// ./src/app/actions/payment-request/index.js